import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'

// helpers
import { showMessage } from "helpers/message.js";

// api
import usuario_api from "api/usuario_api.js";
import regional_api from "api/regional_api.js";
import grupo_api from "api/grupo_api.js";

export default function UsuarioFicha({ item, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);
    const [showLoadingRegionais, setshowLoadingRegionais] = useState(false);
    const [showLoadingGrupos, setshowLoadingGrupos] = useState(false);

    // Status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" }
    ];
    const [status, set_status] = useState(null);
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    // Perfil
    const options_perfil = [
        { label: "Administrador", value: "Administrador" },
        { label: "Usuário", value: "Usuário" }
    ];

    const [perfil, set_perfil] = useState(null);
    const handleChangePerfil = (value) => {
        set_perfil(value);
        clearErrors("perfil");
        setValue("perfil", value, true);
    }

    // Perfil
    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        setshowLoadingRegionais(true);
        regional_api.getAll().then(result => {
            setshowLoadingRegionais(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_regionais(result.data);
            }
        });
    }
    const [regionais, set_regionais] = useState([]);
    const handleChangeRegionais = (value) => {
        let _regionais = [];
        value.map(m => {
            _regionais.push({
                mapaRegional_Id: m.mapaRegional_Id,
                usuario_Id: item != null ? item.usuario_Id : 0,
                usuarioRegional_Id: item != null ? item.usuarioRegionais.filter(f => f.mapaRegional_Id == m.regiomapaRegional_Idnal_Id)[0]?.usuarioRegional_Id : 0
            });
        })
        set_regionais(_regionais);

        if (_regionais.length > 0) {
            setValue("regionais", _regionais, true);
            clearErrors("regionais");
        }
        else {
            setValue("regionais", [], false);
        }
    }

    // Grupos
    const [options_grupos, set_options_grupos] = useState([]);
    const loadOptionsGrupos = () => {
        setshowLoadingGrupos(true);
        grupo_api.getAll().then(result => {
            setshowLoadingGrupos(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_grupos(result.data);
            }
        });
    }
    const [grupos, set_grupos] = useState([]);
    const handleChangeGrupos = (value) => {
        let _grupos = [];
        value.map(m => {
            _grupos.push({
                grupo_Id: m.grupo_Id,
                usuario_Id: item != null ? item.usuario_Id : 0,
                usuarioGrupo_Id: item != null ? item.usuarioGrupos.filter(f => f.grupo_Id == m.grupo_Id)[0]?.usuarioGrupo_Id : 0
            });
        })
        set_grupos(_grupos);

        if (_grupos.length > 0) {
            setValue("grupos", _grupos, true);
            clearErrors("grupos");
        }
        else {
            setValue("grupos", [], false);
        }
    }

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        loadOptionsRegionais();
        loadOptionsGrupos();
        loadForm();
    }, []);

    const loadForm = () => {
        if (item != null) {
            setValue("email", item.email);
            setValue("nome", item.nome);            
            set_status(item.status);
            setValue("status", item.status, true);
            set_perfil(item.perfil);
            setValue("perfil", item.perfil, true);

            if (item.perfil == "Usuário") {
                set_regionais(item.usuarioRegionais);
                set_grupos(item.usuarioGrupos);
            }            
        }
    }

    const onSubmit = (data) => {
        if (showLoadingRegionais && perfil == "Usuário") {
            showMessage("Aviso", "Aguarde a tela carregar as Regionais antes de salvar.", 'info', null);
            return;
        }

        let json_submit = {
            usuario_Id: item ? item.usuario_Id : 0,
            nome: data.nome,
            perfil: perfil,
            status: status,
            email: data.email,
            usuarioRegionais: regionais,
            usuarioGrupos: grupos
        };

        setshowLoading(true);
        if (json_submit.usuario_Id == 0)
            usuario_api.post(json_submit).then(result => handleReturnSubmit(result));
        else
            usuario_api.put(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">

                <Row>
                    <Col md="12">
                        <Button color="default" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Usuário</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col lg="6" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">E-mail</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="email"
                                            innerRef={register({ required: true })}
                                        />
                                        {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Nome</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="nome"
                                            innerRef={register({ required: true })}
                                        />
                                        {errors.nome && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Status</label>
                                        <Select
                                            name="status"
                                            options={options_status}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_status.filter(f => f.value == status)}
                                            onChange={(o) => handleChangeStatus(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "status" },
                                                { required: true })
                                            }
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Perfil</label>
                                        <Select
                                            name="perfil"
                                            options={options_perfil}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_perfil.filter(f => f.value == perfil)}
                                            onChange={(o) => handleChangePerfil(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "perfil" },
                                                { required: true })
                                            }
                                        />
                                        {errors.perfil && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className={perfil == "Usuário" ? "" : "d-none"}>
                                <Col lg="12" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Grupos</label>
                                        <Select
                                            name="grupos"
                                            options={options_grupos}
                                            getOptionLabel={o => o.descricao}
                                            getOptionValue={o => o.grupo_Id}
                                            value={options_grupos.filter(({ grupo_Id }) => grupos.filter(f => f.grupo_Id == grupo_Id).length > 0)}
                                            onChange={(o) => handleChangeGrupos(o)}
                                            classNamePrefix="select"
                                            isLoading={showLoadingGrupos}
                                            placeholder="[ Selecione ]"
                                            isMulti={true}
                                            ref={e => register(
                                                { name: "grupos" },
                                                { required: false })
                                            }
                                        />
                                        {errors.grupos && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="12" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Regionais</label>
                                        <Select
                                            name="regionais"
                                            options={options_regionais}
                                            getOptionLabel={o => o.nomeRegional}
                                            getOptionValue={o => o.mapaRegional_Id}
                                            value={options_regionais.filter(({ mapaRegional_Id }) => regionais.filter(f => f.mapaRegional_Id == mapaRegional_Id).length > 0)}
                                            onChange={(o) => handleChangeRegionais(o)}
                                            classNamePrefix="select"
                                            isLoading={showLoadingRegionais}
                                            placeholder="[ Selecione ]"
                                            isMulti={true}
                                            ref={e => register(
                                                { name: "regionais" },
                                                { required: false })
                                            }
                                        />
                                        {errors.regionais && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" className="text-center">
                                    <Button color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

